import { classNames } from "src/helpers/classNames";
import PreloaderIcon from "src/components/shared/LoadingAnimations/PreloaderIcon";

const Preloader = ({ text = "Loading...", className = "", size = "lg", circleDimension = "14" }) => {
  return (
    <div className={classNames("flex flex-col items-center justify-center rounded", text ? "gap-y-4" : "", className)}>
      <PreloaderIcon
        height={`h-${circleDimension}`}
        width={`w-${circleDimension}`}
      />
      <p
        style={{
          fontFamily: "Lato",
          fontWeight: 500,
        }}
        className={`m-0 text-${size} text-gray-400`}>
        {text}
      </p>
    </div>
  );
};

export default Preloader;
